
import React from 'react';
import Layout from '@/components/layout/Layout';
import RoleDashboardRouter from '@/components/dashboard/RoleDashboardRouter';

const Dashboard: React.FC = () => {
  return (
    <Layout>
      <RoleDashboardRouter />
    </Layout>
  );
};

export default Dashboard;
